import apiWorker from '../apiWorker'

const leads = {
    search: (data) =>  apiWorker('post', `/api/v1/core/leads/search`, data),
    merge: (data) =>  apiWorker('post', `/api/v1/core/leads/merge`, data, true),
}

export default leads;